import { Button, Grid, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

import { sxStyle } from './styles';

export default () => {
  const history = useHistory();

  return (
    <Grid container sx={sxStyle.root} data-testid={`notFoundView_view`}>
      <Grid sx={sxStyle.alertContainer}>
        <Typography
          variant="h5"
          align="center"
          sx={{ color: '#ff444a', fontSize: '28px' }}
        >
          Lo sentimos, esta página no existe
        </Typography>
      </Grid>
      <Grid sx={sxStyle.returnContainer}>
        <Button
          color="primary"
          variant="contained"
          align="center"
          sx={sxStyle.link}
          onClick={() => {
            history.push('/');
          }}
        >
          Volver a la página principal
        </Button>
      </Grid>
    </Grid>
  );
};
